import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDistrictsApiClient } from './i-districts-api.client';
import {
  IDistrictResponse,
  ICreateDistrictRequest,
  IUpdateDistrictReqeust,
} from '../dtos';
import { LocationManagementCollections } from '../../common/collections';
import { CollectionApiClient, IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { ICreateDistrictResponse } from '../dtos/responses/create-districts.response';

@Injectable({
  providedIn: 'root'
})
export class DistrictsApiClient implements IDistrictsApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(
      LocationManagementCollections.Districts,
      http
    );
  }

  get(
      paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<IDistrictResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<IDistrictResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateDistrictRequest): Observable<ICreateDistrictResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateDistrictReqeust): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }
}
